<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editData" ref="editDataRef" label-width="110px">
          <el-form-item label="产品名称" class="addAdminForm">
            <el-input v-model="editData.name" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品简介" class="addAdminForm">
            <el-input v-model="editData.content" placeholder="请输入产品简介"></el-input>
          </el-form-item>
          <el-form-item label="产品图片" class="addAdminForm">
            <el-input v-model="editData.pic" placeholder="请输入产品图片"></el-input>
          </el-form-item>
          <el-form-item label="排序" class="addAdminForm">
            <el-input v-model="editData.listorder" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editData: {
        id: '0',
        name: '',
        content: '',
        pic: '',
        listorder: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.name = row.Name
      this.editData.content = row.Content
      this.editData.pic = row.Pic
      this.editData.listorder = row.Listorder
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteProductEvolution()
    },
    EditKgjtWebsiteProductEvolution: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        name: that.editData.name,
        content: that.editData.content,
        pic: that.editData.pic,
        listorder: that.editData.listorder
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteProductEvolution, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
